export function moreProductSlider() {
    const slider = $(".more-product-slider");

    function sliderInit() {
        slider.slick({
            infinite: false,
            mobileFirst: true,
            dots: true,
            arrows: false,
            slidesToScroll: 1,
            slidesToShow: 1,
            swipeToSlide: true,
            responsive: [
                {
                    breakpoint: 568,
                    settings: {
                        slidesToShow: 2
                    }
                },{
                    breakpoint: 1200,
                    settings: {
                        dots: false,
                        slidesToShow: 3
                    }
                },{
                    breakpoint: 1440,
                    settings: {
                        slidesToShow: 4
                    }
                },{
                    breakpoint: 1800,
                    settings: {
                        slidesToShow: 3.9
                    }
                }
            ]
        });
    }

    sliderInit();
}


// WEBPACK FOOTER //
// ./assets/js/modules/moreProductSlider.js